/* eslint-disable node/no-unsupported-features/es-syntax */
/* eslint-disable filenames/no-index */
import { SpawnGameLauncher } from "@spawn/launcher";

SpawnGameLauncher.entrypoint = () => import(/* webpackChunkName: "game" */ "./main");
